/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetListConstraintsRequest {
    getFixupPrototypeFunction() { return BudgetListConstraintsRequest.fixupPrototype; }

    static newInstance(model: Partial<BudgetListConstraintsRequest>): BudgetListConstraintsRequest {
        let obj = Object.assign(new BudgetListConstraintsRequest(), model);
        BudgetListConstraintsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetListConstraintsRequest>): BudgetListConstraintsRequest {
        if (!model) return null;
        return BudgetListConstraintsRequest.newInstance(<BudgetListConstraintsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetListConstraintsRequest) {
        if (!obj) return;

        models.BudgetListConstraintsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetListConstraintsRequest): boolean {
        Object.setPrototypeOf(obj, BudgetListConstraintsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List constraints based on filter key. Allowed values are region/resource_group/linked_accounts/projects/resource_type/tags
     */
    filter_key: string;

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenant_id: string;

    /**
     * Specify the cloud account id to view, cloud account id is unique can be obtained from the list cloud account api.
     */
    cloud_account_id: Array<string>;

}
